module.exports = __webpack_public_path__ + "web_static/img/smart1.a2ef87a0.png";